<div class="form-check d-flex align-items-center mb-1 mt-1">
    <input
        #input
        class="form-check-input"
        type="checkbox"
        [id]="inputId"
        [required]="required"
        [checked]="checked"
        [attr.value]="value"
        [disabled]="disabled"
        [attr.name]="name"
        [tabIndex]="tabIndex"
        [attr.aria-label]="ariaLabel || null"
        [attr.aria-checked]="getAriaChecked()"
        (change)="onInteractionEvent($event)"
        (click)="onInputClick($event)"
        data-uit="ca-input-checkbox-button"
    />
    <label data-uit="ca-input-checkbox-label" [attr.for]="inputId" class="form-check-label font-m ms-2 mb-0" tabindex="0">
        <span class="text-truncate"><ng-content></ng-content></span>
    </label>
</div>
